import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const UnsubscribeContainer = styled.div`
  padding: 30px 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const UnsubscribeLogoLink = styled(Link)`
  margin-bottom: 40px;
  display: flex;
  align-items: center;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    margin-bottom: 20px;
  }
`

export const UnsubscribeLogo = styled.img`
  width: 130px;
  height: auto;
  ${({theme}) => theme.breakpoints.down('mobileL')} {
    width: 100px;
  }
`

export const UnsubscribeImg = styled.img`
  margin: 0 auto 25px;
  max-width: 255px;
  width: 100%;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    margin-bottom: 15px;
    max-width: 200px;
  }
`

export const UnsubscribeTitle = styled.h1`
  margin-top: 0;
  margin-bottom: 18px;
  font-weight: 500;
  font-size: ${({theme}) => theme.fontSizes.titleLarge};

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    margin-bottom: 10px;
    font-size: ${({theme}) => theme.fontSizes.title};
  }
`

export const UnsubscribeSubTitle = styled.p`
  margin: 0 auto 27px;
  max-width: 518px;
  width: 100%;
  white-space: pre-line;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    font-size: ${({theme}) => theme.fontSizes.default};
  }
`

export const UnsubscribeBtns = styled.div`
  display: flex;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    flex-direction: column;
    align-items: center;
  }
`
export const UnsubscribeBtnWrapper = styled.div`
  &:first-of-type {
    margin-right: 20px;

    ${({theme}) => theme.breakpoints.down('mobileL')} {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
`
